export const skipToken = Symbol.for("apollo.skipToken");
export type SkipToken = typeof skipToken;
